import { getRequest, postRequest, downloadRequest, replaceInUrl } from '.';
import apiEndpoints from './apiEndpoints';

export const downloadAchAgreementRequest = ({ ApplicationUid }) =>
  getRequest(
    replaceInUrl(apiEndpoints.agreements.download.achAgreement, {
      ApplicationUid,
    }),
  );

export const downloadIraAgreementRequest = ({ ApplicationUid }) =>
  getRequest(
    replaceInUrl(apiEndpoints.agreements.download.iraAgreement, {
      ApplicationUid,
    }),
  );

export const downloadHaaAgreementRequest = ({ ApplicationUid }) =>
  getRequest(
    replaceInUrl(apiEndpoints.agreements.download.haaAgreement, {
      ApplicationUid,
    }),
  );

export const downloadMetalStreamAgreementRequest = ({ ApplicationUid }) =>
  getRequest(
    replaceInUrl(apiEndpoints.agreements.download.metalStreamAgreement, {
      ApplicationUid,
    }),
  );

export const downloadPDFAchAgreementRequest = ({ ApplicationUid }) =>
  downloadRequest(
    replaceInUrl(apiEndpoints.agreements.downloadPdf.achAgreement, {
      ApplicationUid,
    }),
  );

export const downloadPDFIraAgreementRequest = ({ ApplicationUid }) =>
  downloadRequest(
    replaceInUrl(apiEndpoints.agreements.downloadPdf.iraAgreement, {
      ApplicationUid,
    }),
  );

export const downloadPDFHaaAgreementRequest = ({ ApplicationUid }) =>
  downloadRequest(
    replaceInUrl(apiEndpoints.agreements.downloadPdf.haaAgreement, {
      ApplicationUid,
    }),
  );

export const downloadPDFMetalStreamAgreementRequest = ({ ApplicationUid }) =>
  downloadRequest(
    replaceInUrl(apiEndpoints.agreements.downloadPdf.metalStreamAgreement, {
      ApplicationUid,
    }),
  );

export const createAchAgreementRequest = ({ ApplicationUid }) =>
  postRequest(
    replaceInUrl(apiEndpoints.agreements.achAgreement, {
      ApplicationUid,
    }),
  );

export const createIraAgreementRequest = ({ ApplicationUid }) =>
  postRequest(
    replaceInUrl(apiEndpoints.agreements.iraAgreement, {
      ApplicationUid,
    }),
  );

export const createHaaAgreementRequest = ({ ApplicationUid }) =>
  postRequest(
    replaceInUrl(apiEndpoints.agreements.haaAgreement, {
      ApplicationUid,
    }),
  );

export const createMetalStreamAgreementRequest = ({ ApplicationUid }) =>
  postRequest(
    replaceInUrl(apiEndpoints.agreements.metalStreamAgreement, {
      ApplicationUid,
    }),
  );
